import { type OfferV11 } from '@redteclab/api/clients/bully'

export const productAccessorGetOfferById = ({
  offerId,
  offers,
}: {
  offerId: string | null
  offers: OfferV11[] | undefined
}): OfferV11 | null => {
  if (!offerId || !offers || offers.length === 0) {
    return null
  }

  return offers.find((offer) => offer.offerId === offerId) ?? null
}
